<template>
    <div class="text-center my-3">
        <button v-if="isLoading" type="button" class="btn rounded-pill btn-secondary">
            <i class="fad fa-spin fa-spinner-third"></i>
        </button>
        <button v-else @click="loadMore" type="button" class="btn rounded-pill btn-secondary">Load More</button>
    </div>
</template>

<script>
    export default {
        props: {
            isLoading: {
                type: [Boolean],
                default: false,
            },
        },
        methods: {
            loadMore: function() {
                this.$emit('load-more');
            },
        },
    }
</script>
